import React from 'react';
import { observer } from 'mobx-react';
import { FixedGrid } from '../../../../../ui';
import { MyBookingsNoResults } from './MyBookingsNoResults';
import { MyBookingCard } from './card/MyBookingCard';
import { MyBookingCardShimmer } from './card/MyBookingCardShimmer';
import { StyledMyBookingCard } from './card/StyledMyBookingCard';
import { IBooking } from '../../../domain/booking/models/IBooking';

interface IMyBookingsContentProps {
	loading?: boolean;
	bookings: IBooking[];
}

export const MyBookingsContent = observer(
	({ loading, bookings }: IMyBookingsContentProps) => {
		if (!loading && bookings.length === 0) {
			return <MyBookingsNoResults />;
		}

		return (
			<FixedGrid
				itemSelector={StyledMyBookingCard}
				columns={[3, { tablet: 2, mobileXL: 1 }]}
			>
				{loading ? (
					<MyBookingCardShimmer />
				) : (
					bookings.map((booking) => (
						<MyBookingCard key={booking.reference} booking={booking} />
					))
				)}
			</FixedGrid>
		);
	},
);
